"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var moment = require('moment');

var OrderNote = require('../orders/classes/OrderNote');

var Transaction = function Transaction() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, Transaction);

  this.id = params.id;
  this.order_id = params.order_id;
  this.amount = params.amount ? parseFloat(params.amount, 10) : 0;
  this.options = params.options || {};
  this.notes = params.notes && Array.isArray(params.notes) ? params.notes.map(function (note) {
    return new OrderNote(note);
  }) : [];
  this.date_created = params.date_created ? moment(params.date_created) : moment();
};

module.exports = Transaction;